import { Outlet } from 'react-router-dom';

export default function MainLayout(props) {
  return (
    <div className="clearfix w-100">
        <Outlet />
    </div>
  );
}